 <template>
  <div>
    <WidgetsDashboardCases v-if="data !== null" :billed="data.casesBill" />
    <WidgetsDashboardInspectors v-if="data !== null" :inspectors="data.inspectors" :statused="data.casesStatus" />
    <CRow>
      <CCol md="12">
        <CasesCalendar v-if="data !== null" :cases="data.allCases" style="height:700px;"/>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CasesCalendar from './plugins/CasesCalendar'
import WidgetsDashboardQuickMenu from './widgets/WidgetsDashboardQuickMenu'
import WidgetsDashboardCases from './widgets/WidgetsDashboardCases'
import WidgetsDashboardInspectors from './widgets/WidgetsDashboardInspectors'
import WidgetsBrand from './widgets/WidgetsBrand'
import axios from 'axios'


export default {
  name: 'Dashboard',
  components: {
    CasesCalendar,
    WidgetsDashboardQuickMenu,
    WidgetsDashboardCases,
    WidgetsDashboardInspectors,
    WidgetsBrand
  },

  data(){
    return {
      data: null
    }
  },

  mounted(){
    this.getData();
  },

  methods: {
    getData() {

      axios.get('/api/dashboard?token=' + localStorage.getItem("api_token"))
      .then(r => {
        this.data = r.data;
      })
      .catch(function (error) {
        console.log(error);
        // self.$router.push({ path: '/login' });
      });
    },
  }
}
</script>